import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'bulletin': null,
  'loading': false,
  'bulletinCreated': false,
  'loadingRecord': false,
  'downloadRecord': [],
  'savedRecord': null,
  'list': [],
  'fileURL': '',
  'loadingFile': false,
  'attachments': [],
  'rawAttachments': [],
};

const urltoFile = async(url, filename, mimeType) => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, {'type': mimeType});
};

const convertBase64ToFiles = (attachments) => {
  const files = [];
  attachments.forEach((item) => {
    const base64 = `data:${item.mimetype};base64, ${item.file}`;
    urltoFile(base64, item.name, item.mimetype).then((file) => {
      files.push(file);
    });
  });
  return files;
};

export const bulletin = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_BULLETIN_SEQUENCE_BY_VEH_SYSTEM]: (
      state,
      action
    ) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM]: (state, action) => {
      const bulletinId = action.response.data;
      return {
        ...state,
        'loading': false,
        'bulletin': {...state.bulletin, bulletinId},
      };
    },
    [ActionTypes.FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_BULLETIN_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_BULLETIN_BY_ID]: (state, action) => {
      const {bulletin, attachments} = action.response.data;
      const convertedAttachments = convertBase64ToFiles(attachments);
      return {
        ...state,
        'loading': false,
        'bulletin': bulletin,
        'attachments': convertedAttachments,
        'rawAttachments': attachments,
      };
    },
    [ActionTypes.FETCHED_BULLETIN_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'bulletin': null,
      'attachments': [],
      'rawAttachments': [],
    }),
    [ActionTypes.ADDING_NEW_BULLETIN_SERVICE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_NEW_BULLETIN_SERVICE]: (state, action) => ({
      ...state,
      'loading': false,
      'bulletin': action.response.data,
      'bulletinCreated': true,
    }),
    [ActionTypes.ADDED_NEW_BULLETIN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'bulletinCreated': false,
    }),
    [ActionTypes.UPDATING_BULLETIN_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_BULLETIN_BY_ID]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_BULLETIN_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DOWNLOADING_BULLETIN_RECORD_FILE]: (state, action) => ({
      ...state,
      'loadingFile': true,
    }),
    [ActionTypes.DOWNLOADED_BULLETIN_RECORD_FILE]: (state, action) => ({
      ...state,
      'loadingFile': false,
      'fileURL': action.response.data,
    }),
    [ActionTypes.DOWNLOADED_BULLETIN_RECORD_FILE_FAILED]: (state, action) => ({
      ...state,
      'loadingFile': false,
      'fileURL': '',
    }),
    [ActionTypes.FETCHING_BULLETIN_DOWNLOAD_RECORD]: (state, action) => ({
      ...state,
      'loadingRecord': true,
    }),
    [ActionTypes.FETCHED_BULLETIN_DOWNLOAD_RECORD]: (state, action) => ({
      ...state,
      'loadingRecord': false,
      'downloadRecord': action.response.data,
    }),
    [ActionTypes.FETCHED_BULLETIN_DOWNLOAD_RECORD_FAILED]: (state, action) => ({
      ...state,
      'loadingRecord': false,
    }),
    [ActionTypes.SAVING_BULLETIN_DOWNLOAD_RECORD]: (state, action) => ({
      ...state,
      'loadingRecord': true,
    }),
    [ActionTypes.SAVED_BULLETIN_DOWNLOAD_RECORD]: (state, action) => ({
      ...state,
      'loadingRecord': false,
      'savedRecord': action.response.data,
    }),
    [ActionTypes.SAVED_BULLETIN_DOWNLOAD_RECORD_FAILED]: (state, action) => ({
      ...state,
      'loadingRecord': false,
      'savedRecord': null,
    }),
    [ActionTypes.SET_BULLETIN_FILES]: (state, action) => ({
      ...state,
      'attachments': action.payload,
    }),
    [ActionTypes.CLEAR_BULLETIN_INFO]: (state, action) => {
      if (state.bulletinCreated) {
        return {
          ...INITIAL_STATE,
          'attachments': state.attachments,
          'rawAttachments': state.rawAttachments,
        };
      }
      return {
        ...INITIAL_STATE,
      };
    },
    [ActionTypes.CLEAR_BULLETIN_URL_FILE]: (state, action) => ({
      ...state,
      'fileURL': '',
      'loadingFile': false,
      'loadingRecord': false,
      'savedRecord': null,
    }),
  })(state, action);
};
